import { create } from "zustand";
import type { ImportMethod } from "@/lib/constants";

type ModalStore = {
  isOpen: boolean;
  onOpen: (method: ImportMethod) => void;
  onClose: () => void;
  method: ImportMethod;
};

const useImportFileModal = create<ModalStore>((set) => ({
  isOpen: false,
  onOpen: (method) => set({ isOpen: true, method }),
  onClose: () => set({ isOpen: false }),
  method: "file_upload",
}));

export default useImportFileModal;
